import { ICON } from './icons';

export const CONTROL_MODE_CATEGORY = {
  HVAC: 'HVAC',
  HVAC_ZONE: 'HVAC_ZONE',
  BATTERY: 'BATTERY',
  EV: 'EV',
  OVERRIDE: 'OVERRIDE',
  EVENT: 'EVENT',
  STANDARD: 'STANDARD',
  UNKNOWN: 'UNKNOWN',
};

// TODO: Export new icon from Figma for unmanaged
export const CONTROL_MODE = {
  LOCAL_OVERRIDE: {
    key: 'Local Override',
    label: 'Local Override',
    icon: ICON.CONTROL_MODE.OVERRIDE,
    category: CONTROL_MODE_CATEGORY.OVERRIDE,
  },
  REMOTE_OVERRIDE: {
    key: 'Remote Override',
    label: 'Remote Override',
    icon: ICON.CONTROL_MODE.OVERRIDE,
    category: CONTROL_MODE_CATEGORY.OVERRIDE,
  },
  EVENT: {
    key: 'Event',
    label: 'Event',
    icon: ICON.CONTROL_MODE.EVENT,
    category: CONTROL_MODE_CATEGORY.EVENT,
  },
  RAMPING_IN: {
    key: 'Ramping In',
    label: 'Ramping In',
    icon: ICON.CONTROL_MODE.ELEXITY,
    color: '#7987E2',
    category: CONTROL_MODE_CATEGORY.HVAC_ZONE,
  },
  RAMPING_OUT: {
    key: 'Ramping Out',
    label: 'Ramping Out',
    icon: ICON.CONTROL_MODE.ELEXITY,
    color: '#E0BA1D',
    category: CONTROL_MODE_CATEGORY.HVAC_ZONE,
  },
  PRECONDITION: {
    key: 'Preconditioning',
    label: 'Precondition',
    icon: ICON.CONTROL_MODE.ELEXITY,
    color: '#D968AB',
    category: CONTROL_MODE_CATEGORY.HVAC,
  },
  RELAX: {
    key: 'Relaxing',
    label: 'Relax',
    icon: ICON.CONTROL_MODE.ELEXITY,
    color: '#06B685',
    category: CONTROL_MODE_CATEGORY.HVAC,
  },
  STANDARD: {
    key: 'Standard',
    label: 'Schedule',
    icon: ICON.CONTROL_MODE.ELEXITY,
    color: '#666666',
    category: CONTROL_MODE_CATEGORY.STANDARD,
  },
  UNMANAGED: {
    key: 'Unmanaged',
    label: 'Unmanaged',
    icon: ICON.ACTIVITY.UNMANAGED,
  },
  OFFLINE: {
    key: 'Offline',
    label: 'Offline',
    icon: ICON.ACTIVITY.OFFLINE,
  },
  DEFAULT: {
    key: 'Default',
    label: 'Default',
    icon: ICON.ACTIVITY.UNMANAGED,
  },
};
